import { Injectable } from '@angular/core';
import { Home } from '../models/home';

const homePromise: Promise<Home[]> = Promise.resolve([
  {
    id: 1,
    heading: "New Safety Programs",
    homeimage: "../../assets/images/safety program.png",
    description: "SFI creates customized written safety programs designed to go Beyond Compliance. " +
      "Our experienced safety consultants conduct a comprehensive review of your operations to identify the policies,procedures, " +
      "and program elements needed to support a safer workplace. Every safety program is tailored to your business, workforce, and specific operational needs." ,
      
    link: "/safetyprogram",
    type: "PROGRAM"
  },
  {
    id: 2,
    heading: "Review and Revise",
    homeimage: "../../assets/images/building.png",
    description: "If your company already has a safety program that works well, SFI can review it to determine whether it aligns with current OSHA requirements, industry standards, and your operational needs. " +
      "Once the review is complete, we will provide recommendations to strengthen and improve the program. In many cases, building on a proven program is the best way to move Beyond Compliance without starting over.",
    link: "/rsp",
    type: "PROGRAM"
  },
  {
    id: 3,
    heading: "Safety Orientation videos",
    homeimage: "../../assets/images/youtube_box.jpeg",
    description: "SFI creates site-specific safety orientation videos that help establish clear safety expectations before workers ever step onto the jobsite. " +
      "Available in English and Spanish, with additional languages upon request, these customized orientations give contractors a consistent way to communicate site rules, hazards, and responsibilities."+
      "By starting every worker with the same foundation, our orientation videos help move projects Beyond Compliance by improving understanding, accountability, and safety from day one.",
      
    link: "/sv",
    type: "PROGRAM"
  },
  {
    id: 4,
    heading: "Training Courses",
    homeimage: "../../assets/images/training room.JPG",
    description: "SFI offers a wide range of safety training courses to help your team build knowledge, confidence, and stronger safety practices. " +
    "Courses include OSHA 10- and 30-Hour, CPR/First Aid/AED certification, fall protection, " +
    "ladder safety, Safety Management 101, OSHA inspection procedures, and more. Explore our scheduled classes, or contact us to arrange a custom course designed to help your team go Beyond Compliance." ,
    
    link: "/safetytraining",
    type: "TRAINING"
  },
  {
    id: 5,
    heading: "On Site Training",
    homeimage: "../../assets/images/HBA and BCB Meeting-2.jpg",
    description: "Bring practical safety training directly to your team. SFI provides hands-on training at your jobsite or office, allowing employees to learn in an environment that reflects the work they perform every day " +
      "On-site options include fall protection training, equipment demonstrations, and realistic drop demonstrations that show the impact of a fall."+
      "Our goal is to make training engaging, memorable, and focused on helping your workforce build safer habits that go Beyond Compliance.",
    link: "/onsitetraining",
    type: "TRAINING"
  },
  {
    id: 6,
    heading: "Online training",
    homeimage: "../../assets/images/training2.png",
    description: "SFI has partnered with ClickSafety to provide convenient online access to hundreds of safety training courses, including OSHA 10, OSHA 30, fall protection, vehicle safety, fire protection, and many other options." +
      "Online training allows employees to complete the courses they need at their own pace and on their own schedule, making it easier to build knowledge, " +
      "strengthen safety awareness, and support a Beyond Compliance culture.",
    link: "https://business.clicksafety.com/sficompliance/",
    type: "TRAINING"
  },
  {
    id: 7,
    heading: "On-site Inspections",
    homeimage: "../../assets/images/training room.JPG",
    description: "SFI safety inspections do more than identify hazards—they help evaluate how effectively your safety program is working in the field."+
    "As an essential part of a complete safety program, our inspections identify unsafe conditions and behaviors before they result in injuries or accidents."+
    "Our consultants use positive reinforcement to strengthen safe work practices while helping supervisors build accountability for maintaining a safe workplace between SFI visits."+
    "This consistent approach helps turn safety from a periodic inspection into an everyday Beyond Compliance mindset.",
    link: "/safetyinspection",
    type: "INSPECTION"
  },
  {
    id: 8,
    heading: "OSHA Assistance",
    homeimage: "../../assets/images/OSHA.png",
    description: "If OSHA visits your jobsite, SFI will be there to help you manage the inspection with confidence."+
    "Our consultants work proactively with OSHA compliance officers to demonstrate your safety efforts, documentation, and the positive steps you have taken to protect your workforce."+
    "After the inspection, we can assist with abatement certifications, corrective actions, and informal conference support. "+
    "Our Beyond Compliance approach helps ensure you are prepared before, during, and after an OSHA visit.",
    link: "/osha",
    type: "INSPECTION"
  },
  {
    id: 9,
    heading: "SFI Safety App",
    homeimage: "../../assets/images/DMS.jpg",
    description: "As an industry leader in construction safety, SFI partners with the SFI Safety App to help ensure your safety efforts are documented, measurable, and easy to manage."+
    "Clients can review key statistics, reports, trends, and scoring features while providing access to authorized users within their organization. SFI-conducted safety inspections include app-based documentation at no additional charge. "+
    "Additional paid features allow your team to conduct its own safety inspections, toolbox talks, safety observations, and incident investigations—helping turn safety activity into measurable Beyond Compliance performance.",
    link: "/dms",
    type: "INSPECTION"
  }

]);

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor() { }

  getHomeDetails() {
    return homePromise;
  }
}
